import React, { useContext, useState, useEffect } from 'react'
import Layout from '@/product/components/templates/Layout'
import CustomTable from '@/product/components/molecules/CustomTable'
import TransactionContext from '@/product/context/transaction/transactionContext'
import CustomSearch from '@/product/components/molecules/CustomSearch'
import { useFormik } from 'formik'
import ReportContext from '@/product/context/report/reportContext'
import { Button } from '@mui/material'
import { handleRedirectInternal } from '@/custom/common/components'
import { useHistory } from 'react-router-dom'

const Transaction = (props) => {
    const reportContext = useContext(ReportContext)
    const transactionContext = useContext(TransactionContext)
    const [isLoading, setIsLoading] = useState(true)
    const {
        all_payment,
        getAllPayment,
        responseStatus: responseStatusInvoice,
        clearResponse: clearResponseInvoice,
    } = transactionContext

    let action =
        props.match.params.action !== 'all' ? props.match.params.action : null
    const { getAllExportDownload } = reportContext

    const [tableBody, setTableBody] = useState([])

    const formik = useFormik({
        initialValues: {
            page: 1,
            limit: 20,
            order: '',
            orderby: '',
            buynowConnect: true,
            project_employee: true,
            wonUser: true,
            checkPayAdmin: true,
            customColoumns: 'p.title  as projects_title',
            checkAgency: true,
            filters: {
                searchterm: {
                    value: '',
                    type: 'like',
                    field: 'par.cart_id',
                },
                fromdate: {
                    value: '',
                    type: 'dategreaterequal',
                    field: 'par.created_at',
                },
                todate: {
                    value: '',
                    type: 'datesmallerequal',
                    field: 'par.created_at',
                },
                buynow_autype: {
                    value: '',
                    type: 'in',
                    field: 'b.buynow_autype',
                },
                user_id: {
                    value: '',
                    type: 'in',
                    field: 'b.user_id',
                },
                product_id: {
                    value: '',
                    type: 'in',
                    field: 'p.id',
                },
            },
        },
        onSubmit: (values) => {
            setIsLoading(true)
            getAllPayment(values)
        },
    })
    const history = useHistory()
    const onClickEdit = (id, secondaryID, type) => {
        handleRedirectInternal(history, `invoice/view/${id}/${secondaryID}`)
    }

    useEffect(() => {
        if (all_payment) {
            setTableBody(all_payment.records.length ? all_payment.records : [])
        }
        setIsLoading(false)
    }, [all_payment])

    useEffect(() => {
        setTableBody([])
        setIsLoading(true)
        formik.values.page = 1
        formik.values.filters.fromdate.value = ''
        formik.values.filters.todate.value = ''
        formik.values.filters.searchterm.value = ''

        getAllPayment(formik.values)
        /* return () => {
            setTableBody([])
        }*/
    }, [action])

    const tableValues = [
        {
            field: 'cart_id',
            type: 'hyperlink',
            firstChild: true,
            sort: false,
            disablePadding: false,
            label: 'Invoice ID',
            click: true,
            onclick: onClickEdit,
            clickID: 'cart_id',
            secondaryClickID: 'user_id',
            filterable: true,
            filterField: 'par.cart_id',
        },
        {
            field: 'trans_id',
            type: '',
            firstChild: false,
            sort: false,
            disablePadding: false,
            label: 'Transaction ID',
            filterable: true,
            filterField: 'par.trans_id',
        },
        {
            field: 'buynow_trans_reference_id',
            type: '',
            firstChild: false,
            sort: false,
            disablePadding: false,
            label: 'Reference ID',
            filterable: true,
            filterField: 'b.trans_reference_id',
        },
        {
            field: 'users_email,users_username',
            type: '',
            sort: false,
            firstChild: false,
            disablePadding: false,
            label: 'Buyer',
            filterable: false,
        },
        {
            field: 'projects_title',
            type: '',
            sort: false,
            firstChild: false,
            disablePadding: false,
            label: 'Project Title',
            filterable: false,
        },

        {
            field: 'amount',
            type: 'price',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Buyer Amount Total',
            filterable: true,
            filterField: 'par.amount',
        },
        {
            field: 'buynow_admin_fee',
            type: 'price',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Post-Sale Handling Fee',
            filterable: false,
            filterField: 'par.amount',
        },
        {
            field: 'buynow_per_total',
            type: 'price',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Buyer Won Amount',
            filterable: false,
            filterField: 'par.amount',
        },
        {
            field: 'pe_as_employees_emp_email,pe_as_employees_username',
            type: '',
            sort: false,
            firstChild: false,
            disablePadding: false,
            label: 'Seller',
            filterable: false,
        },
        {
            field: 'created_at',
            type: 'date',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Created Date',
        },
        // {
        //     field: 'buynow_admin_fee',
        //     type: 'price',
        //     sort: true,
        //     firstChild: false,
        //     disablePadding: false,
        //     label: 'Status',
        // },
    ]

    const searchInfo = {
        formik: formik,
        data: [
            {
                label: 'User ID',
                placeholder: 'Enter User ID',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'text',
                name: 'user_id',
                filter: true,
            },
            {
                label: 'Product ID',
                placeholder: 'Enter Product ID',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'text',
                name: 'product_id',
                filter: true,
            },
            {
                label: 'Invoice Number',
                placeholder: 'Enter invoice number',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'text',
                name: 'searchterm',
                filter: true,
            },
            {
                label: 'Created From Date',
                placeholder: 'Date Ending from',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'date',
                name: 'fromdate',
                filter: true,
            },
            {
                label: 'Created To Date',
                placeholder: 'Date Ending To',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'date',
                name: 'todate',
                filter: true,
            },
            {
                name: 'buynow_autype',
                type: 'select',
                options: [
                    { show: 'Buy Now', value: 'buynow' },
                    { show: 'Auction', value: 'live' },
                ],
                class: 'col-md-4 col-sm-6 col-12',
                placeholder: 'Select Type',
                label: 'Buying Type:',
                filter: true,
            },
        ],
    }

    const resetForm = () => {
        formik.values.filters.fromdate.value = ''
        formik.values.filters.todate.value = ''
        formik.values.filters.searchterm.value = ''
        formik.values.filters.buynow_autype.value = ''
        getAllPayment(formik.values)
    }

    const tableActions = []

    return (
        <Layout>
            <div className="dashboard invoice">
                <CustomSearch
                    searchInfo={searchInfo}
                    formik={formik}
                    // advFilters={true}
                    resetForm={resetForm}
                />
                <Button
                    id="transaction_report"
                    onClick={() =>
                        getAllExportDownload({
                            action: 'export',
                            order: 'asc',
                            orderby: '',
                            search: 'all',
                            report: `transaction_list`,
                        })
                    }
                >
                    <span className="material-icons">get_app</span>Export All
                    Data
                </Button>
                <CustomTable
                    formik={formik.values}
                    tableBody={tableBody}
                    tableValues={tableValues}
                    tableActions={tableActions}
                    allData={all_payment}
                    isLoading={isLoading}
                    loadingTemplate={'table'}
                    changeTableFunction={getAllPayment}
                    columnStorageVariable={'table_transaction_payment'}
                />
            </div>
        </Layout>
    )
}

export default Transaction
